// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-l_gR","advertDetailContactGroup__header":"c-l_gS","advertDetailContactGroup__value":"c-l_gT"};